'use strict';

var angularModule = angular.module('t2g.common.data-access.office', [
  'ngResource',
  require('t2g.common.services.cacheService').name,
  require('t2g.common.services.sessionStorage').name,
  require('t2g.common.services.userSessionService').name,
]);

module.exports = angularModule;

angularModule.factory('OfficeResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/office/:officeId/:embeddedDocument';

  var resource = $resource(
    resourceUrl,
    {},
    {
      update: { method: 'PUT' },
      deleteImage: { method: 'DELETE' },
    },
  );

  return resource;
});

angularModule.factory('OfficeDA', function(
  $q,
  $rootScope,
  gettextCatalog,
  OfficeResource,
  OfficeCache,
  UserSession,
) {
  return {
    get: get,
    update: update,
  };

  function get() {
    var cachedOffice = OfficeCache.get('office');

    if (cachedOffice === undefined) {
      return OfficeResource.get({ officeId: UserSession.getOffice() })
        .$promise.then(function(response) {
          var userSession = UserSession.get();

          OfficeCache.put('office', response);

          if (response.billing) {
            userSession.account = response.billing.account;
          }

          UserSession.set(userSession);

          return response;
        })
        .catch(function(error) {
          return $q.reject('cant load office data: ' + error);
        });
    } else {
      return $q.when(cachedOffice);
    }
  }

  function update(office) {
    return OfficeResource.update({ officeId: UserSession.getOffice() }, office)
      .$promise.then(function(response) {
        OfficeCache.remove('office');
        OfficeCache.put('office', response);
        $rootScope.$broadcast('Office:update', response);

        return response;
      })
      .catch(function(error) {
        return $q.reject('cant update office data: ' + error);
      });
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/office.js